module.exports = __webpack_public_path__ + "img/selected4-min.6590846b.png";